import { render, staticRenderFns } from "./ExclusionesView.vue?vue&type=template&id=cd24fcdc&scoped=true"
import script from "./ExclusionesView.vue?vue&type=script&lang=js"
export * from "./ExclusionesView.vue?vue&type=script&lang=js"
import style0 from "./ExclusionesView.vue?vue&type=style&index=0&id=cd24fcdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd24fcdc",
  null
  
)

export default component.exports